module.exports = __webpack_public_path__ + "static/media/optimization.334a21da.png";